import {
    getWmsAssociationCreationData,
    getWmsAssociations, modifyAssociation,
    newAssociation
} from "../../../../api/wms/wmsAssociation/wmsAssociation";

export function init(currentInventoryId, page) {
    return getWmsAssociations(currentInventoryId, page).then(response => {
        let data = {
            index: 0,
            totalPageCount: Math.ceil(response.itemsCount / 30),
            items: response.response
        }
        return data
    })
}

export function getAddAssociationData(currentInventoryId) {
    return getWmsAssociationCreationData(currentInventoryId).then(response => {
        return response
    })
}

export function createAssociation(currentInventorId, brand, retailer, category, firstPlace, secondPlace) {
    return newAssociation(currentInventorId, brand, retailer, category, firstPlace, secondPlace)
}

export function patchAssociation(associationId, currentInventoryId, brand, retailer, category, firstPlace, secondPlace) {
    return modifyAssociation(associationId, currentInventoryId, brand, retailer, category, firstPlace, secondPlace)
}